import { render, staticRenderFns } from "./VerDevolucionCodigos.vue?vue&type=template&id=8f4ba93c&scoped=true"
import script from "./VerDevolucionCodigos.vue?vue&type=script&lang=js"
export * from "./VerDevolucionCodigos.vue?vue&type=script&lang=js"
import style0 from "./VerDevolucionCodigos.vue?vue&type=style&index=0&id=8f4ba93c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f4ba93c",
  null
  
)

export default component.exports